import styled from "styled-components"
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined'

interface HelperTextProps {
    label: string
}

// ต้องอยู่ใน flow ปกติ (ไม่ absolute) เพื่อให้ .MuiFormHelperText-root มีความสูงจริง
// ไม่งั้นข้อความ error จะไปทับ label ของช่องถัดไป และไอคอนโดน label พื้นขาวบัง (MN-2610-1267)
const CustomHelperText = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    path: {
        fill: '#B00020'
    },
    span: {
        color: '#B00020',
        fontSize: 12,
        paddingLeft: 4
    },
}))

export function HelperText(props: HelperTextProps) {
    return (
        <CustomHelperText>
            <ErrorOutlinedIcon sx={{ fontSize: 13 }} />
            <span>{props.label}</span>
        </CustomHelperText>
    )
}
